import React from 'react';
import { Props } from './renderContent';
import TextBox from '../TextBox/TextBox';
import { FONT_SIZE } from '../TextBox/constants';

const Title = ({ children, options }: Props) => React.createElement(TextBox, { children, options, size: FONT_SIZE.LARGE });

export default Title;